export const apiUrl = process.env.REACT_APP_API_URL
// export const apiUrl = "http://192.168.1.10:3100/api"
// export const apiUrl = "http://localhost:8200/api"
// export const apiUrl = "https://ileadnewapi.secretdemo.com/api"
export const zoomApiUrl = process.env.REACT_APP_ZOOM_API_URL
export const messageCenterUrl = process.env.REACT_APP_MESSAGE_CENTER_URL
export const redirectAdminURL = process.env.REACT_APP_REDIRECT_AMIN_URL